import { render, staticRenderFns } from "./Nisa.vue?vue&type=template&id=3c1f5324&scoped=true&"
import script from "./Nisa.vue?vue&type=script&lang=js&"
export * from "./Nisa.vue?vue&type=script&lang=js&"
import style0 from "./Nisa.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Nisa.vue?vue&type=style&index=1&id=3c1f5324&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1f5324",
  null
  
)

export default component.exports